import connectImg from '#/assets/testnet.png';
import {Modal} from '#/atoms/modal';
import {ButtonPrimary} from '#/components/buttons/primary-button';
import {useModalContext} from '#/contexts/modal-provider';
import {FunctionComponent, ReactElement} from 'react';
import {useTranslation} from 'react-i18next';

export type Content = {
  Icon: ReactElement<any, any>;
  header: string;
  sub?: string;
};

export const AfterLoginModal: FunctionComponent = () => {
  const {t} = useTranslation('translation');
  const {close} = useModalContext();

  return (
    <Modal title='' onClose={close} hideOnClickAway={false} className='rounded-3xl border-none'>
      <div className='w-full max-w-[700px] mx-auto rounded-2xl overflow-y-auto'>
        <>
          <img src={connectImg} alt='connect_image' className='w-full h-auto' />
          <div className='flex justify-center py-6 md:py-10 flex-col items-center'>
            <div className='w-full md:w-4/5 px-4 md:px-0'>
              <h6 className='font-bold text-xl md:text-2xl mb-4 md:mb-6 text-center'>
                {t('pages.landing.afterLogin.subTitle')}
              </h6>
            </div>
            <div className='w-full px-12'>
              <p className='text-center text-gray-500'>{t('pages.landing.afterLogin.description')}</p>
            </div>
            <div className='mt-8'>
              <ButtonPrimary className='pl-16 pr-16' onClick={() => close()}>
                {t('welcome.continue')}
              </ButtonPrimary>
            </div>
          </div>
        </>
      </div>
    </Modal>
  );
};
